import React from 'react';

import { Box, forwardRef } from '@chakra-ui/react';

interface Props {
  children: React.ReactNode;
  ref: React.RefObject<HTMLDivElement>;
}

const SectionCard = forwardRef<Props, 'div'>(({ children }, ref) => (
  <Box py={3} px={0} bg="white" ref={ref} borderRadius="8px">
    {children}
  </Box>
));

export { SectionCard };
